import {
  Component,
  OnInit,
  ViewChild,
  HostListener,
  ElementRef, type OnDestroy,
} from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { FormViewService } from '@xilo-mono/form-contracts';
import { ReplaySubject, takeUntil } from 'rxjs';

@Component({
  selector: 'xilo-mono-form-viewer-question-wrapper-panel',
  templateUrl: './question-wrapper.component.html',
  styleUrls: ['./question-wrapper.component.scss'],
})
export class FormViewerQuestionPanelWrapperComponent
  extends FieldWrapper
  implements OnInit, OnDestroy {
  @ViewChild('header') header: ElementRef;
  width = window.innerWidth;

  isClosed = false;
  private readonly destroyed$ = new ReplaySubject<boolean>(1);

  constructor(private formViewService: FormViewService) {
    super();
  }

  ngOnInit() {
    this.formViewService.scrollState.pipe(
      takeUntil(this.destroyed$)
    ).subscribe((key) => {
      if (
        this.field.parent &&
        this.field.parent.type === 'intake-repeat' &&
        this.field.parent.key === key
      ) {
        this.header.nativeElement.scrollIntoView({ behavior: 'smooth' });
      } else if (key === this.field.key) {
        this.header.nativeElement.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  get isMobile() {
    return this.width <= 767;
  }

  onRepeat() {
    this.field.parent.templateOptions.onAdd();
    this.field.parent.templateOptions.subIndex =
      this.field.parent.model.length - 1;
  }

  onSwitchSubIndex(index: number) {
    this.field.parent.templateOptions.subIndex = index;
  }

  subIndexIsActive(subIndex: string | number) {
    return this.field.parent.templateOptions.subIndex === subIndex;
  }

  onRemoveObject(index: number) {
    if (this.field.parent.templateOptions.subIndex === index) {
      this.field.parent.templateOptions.subIndex = 0;
    } else {
      --this.field.parent.templateOptions.subIndex;
    }
    this.field.parent.templateOptions.onRemove(index);
  }

  isValidUrl(urlString: string) {
    try {
      return Boolean(new URL(urlString));
    } catch (e) {
      return false;
    }
  }
}
